export const isStringNullishOrEmpty = (str) => str === undefined || str === null || str.trim() === "";
export const isStringNullish = (str) => str === undefined || str === null;

export const uncapitalize = (str) => {
	if(!str) {
		return str;
	}
	return str.charAt(0).toLowerCase() + str.slice(1);
};